import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=667845cf&scoped=true"
import script from "./MenuForm.vue?vue&type=script&lang=js"
export * from "./MenuForm.vue?vue&type=script&lang=js"
import style0 from "./MenuForm.vue?vue&type=style&index=0&id=667845cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667845cf",
  null
  
)

export default component.exports